/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatientCancellationListEntry
 */
export interface PatientCancellationListEntry {
    /**
     * 
     * @type {string}
     * @memberof PatientCancellationListEntry
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCancellationListEntry
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCancellationListEntry
     */
    information?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCancellationListEntry
     */
    confirmed_at?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientCancellationListEntry
     */
    unanswered_asks?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCancellationListEntry
     */
    appointment_id?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCancellationListEntry
     */
    appointment_date?: number;
}

/**
 * Check if a given object implements the PatientCancellationListEntry interface.
 */
export function instanceOfPatientCancellationListEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatientCancellationListEntryFromJSON(json: any): PatientCancellationListEntry {
    return PatientCancellationListEntryFromJSONTyped(json, false);
}

export function PatientCancellationListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientCancellationListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'information': !exists(json, 'information') ? undefined : json['information'],
        'confirmed_at': !exists(json, 'confirmed_at') ? undefined : json['confirmed_at'],
        'unanswered_asks': !exists(json, 'unanswered_asks') ? undefined : json['unanswered_asks'],
        'appointment_id': !exists(json, 'appointment_id') ? undefined : json['appointment_id'],
        'appointment_date': !exists(json, 'appointment_date') ? undefined : json['appointment_date'],
    };
}

export function PatientCancellationListEntryToJSON(value?: PatientCancellationListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': value.date,
        'information': value.information,
        'confirmed_at': value.confirmed_at,
        'unanswered_asks': value.unanswered_asks,
        'appointment_id': value.appointment_id,
        'appointment_date': value.appointment_date,
    };
}

